module.exports = __webpack_public_path__ + "assets/img/s2-tab-2-active-5212cf82.png";